import React, { useState } from 'react';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '共有者の一人と連絡が取れません。それでも処分できますか？',
      answer: '可能です。不在者財産管理人の選任申立てや、共有物分割請求訴訟などの方法があります。共有者と連絡が取れない場合でも、法的手続きを通じて不動産の処分を進めることができます。当事務所では、このような複雑なケースにも対応しております。'
    },
    {
      question: '遺産分割協議が終わっていませんが、相談できますか？',
      answer: 'はい、もちろん可能です。遺産分割協議のサポートから対応いたします。相続人の確定、遺産の調査、協議書の作成まで、一貫してサポートいたします。遺産分割協議が終わっていない状態でも、まずはご相談ください。'
    },
    {
      question: '相談だけでも大丈夫ですか？',
      answer: '初回相談は無料です。ご依頼を強制することはありませんので、お気軽にご相談ください。まずは現在の状況をお聞きし、最適な解決方法をご提案いたします。対面またはWeb会議での相談が可能です。'
    },
    {
      question: '共有物分割請求とは何ですか？',
      answer: '共有物分割請求とは、共有者間で話し合いがまとまらない場合に、裁判所を通じて共有状態を解消する手続きです。裁判所が、不動産を現物分割、代償分割、または競売による換価分割のいずれかの方法で分割を命じます。最終手段ではありますが、確実に共有状態を解消できる方法です。'
    },
    {
      question: '費用はどのくらいかかりますか？',
      answer: 'ケースにより異なりますが、初回相談は無料です。具体的な費用については、状況をお伺いした上でお見積りいたします。着手金、成功報酬、実費などの内訳を明確にご説明いたしますので、ご安心ください。'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            よくあるご質問
          </h2>
          <p className="text-xl text-gray-600">
            共有不動産の処分に関するよくある質問
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-orange-300 transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full p-6 text-left hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start flex-1">
                    <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mr-4 mt-1">
                      <span className="text-orange-600 font-bold">Q</span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 pr-4">
                      {faq.question}
                    </h3>
                  </div>
                  <div className="flex-shrink-0 ml-4">
                    <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-500 transition-transform duration-200`}></i>
                  </div>
                </div>
              </button>

              <div
                className={`transition-all duration-500 ease-in-out ${
                  openIndex === index
                    ? 'max-h-96 opacity-100'
                    : 'max-h-0 opacity-0'
                } overflow-hidden`}
              >
                <div className="px-6 pb-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                      <span className="text-green-600 font-bold">A</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            その他のご質問がございましたら、お気軽にお問い合わせください
          </p>
          <a
            href="#cta"
            className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-line text-xl mr-2"></i>
            無料相談で質問する
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
